import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../../apiclient/apiclient";
import ProfileCard from "./ProfileCard";
import PageHeader from "../../components/PageHeader";
import { ArrowLeft } from "lucide-react";
import Loader from "../../components/Loader";// 👈 import loader

const MyProfile = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // 👈 loading state
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await apiClient.get("/user/me");
        setUser(res.data.user);
      } catch (error) {
        console.error("Error fetching user:", error);
      } finally {
        setLoading(false); // 👈 stop loading
      }
    };

    fetchUser();
  }, []);

  return (
    <div className="px-3">
      <PageHeader
        title="My Profile"
        role="agent"
        variant="orange"
        leftContent={
          <button onClick={() => navigate(-1)}>
            <ArrowLeft size={22} />
          </button>
        }
      />

      {/* ✅ Show Loader While Fetching */}
      {loading ? (
        <div className="flex justify-center items-center h-60">
          <Loader />
        </div>
      ) : (
        <div className="px-3">
          <ProfileCard
            user={user}
            showEdit={true}
            onEdit={() => navigate(`/profile/edit/${user?._id}`)}
          />
        </div>
      )}
    </div>
  );
};

export default MyProfile;